<div class="card-view-container">
  <div class="cards-grid">
    @for (measure of measures; track measure.Id) {
      <abc-card>
        <div class="measure-card" (click)="onCardClick(measure)">
          <div class="card-header">
            <div class="card-header-inner">
              <div class="card-title-row">
                <div class="title-subproject">
                  <h3 class="card-title" [title]="measure.Designation">
                    {{ measure.Designation }}
                  </h3>
                  <span class="subproject-label"
                    >{{ dataService.res("Ubt-Measure-List-SubProject") }}:
                    {{ measure.ParentId }}</span
                  >
                </div>
                <div class="card-actions">
                  @if (measure.IsFavorite === 0) {
                    <button
                      class="action-btn"
                      (click)="onToggleFavorite($event, measure)"
                    >
                      <img
                        class="favourite-img"
                        src="assets/images/favorite-inactive.svg"
                      />
                    </button>
                  } @else {
                    <button
                      class="action-btn"
                      (click)="onToggleFavorite($event, measure)"
                    >
                      <img
                        class="favourite-img"
                        src="assets/images/favorite-active.svg"
                      />
                    </button>
                  }
                  <button
                    class="action-btn context-btn"
                    (click)="onContextMenuOpen($event, measure)"
                  >
                    ⋮
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="two-col-row">
              <div class="field-block">
                <span class="field-label">{{
                  dataService.res("Ubt-Measure-List-IdRefPersonResponsible")
                }}</span>
                <span
                  class="field-value responsible-name"
                  [attr.data-tooltip]="
                    getPersonName(measure.IdRefPersonResponsible)
                  "
                >
                  {{ getPersonName(measure.IdRefPersonResponsible) }}
                </span>
              </div>
            </div>

            <div class="date-progress-row">
              <div class="labels-row">
                <div class="date-label-col">
                  <span class="field-label">
                    {{ dataService.res("Ubt-Measure-List-StartDate") }}
                  </span>
                </div>
                <div class="date-label-col">
                  <span class="field-label">
                    {{ dataService.res("Ubt-Measure-List-EndDate") }}
                  </span>
                </div>
                <div class="progress-label-col">
                  <span class="field-label">
                    {{ dataService.res("Ubt-MeasureDetail-Chart-Progress") }}
                  </span>
                </div>
              </div>

              <div class="values-row">
                <div class="date-label-col">
                  <span class="field-value">
                    {{
                      measure?.StartDate
                        ? (measure.StartDate | date: "shortDate" : "" : locale)
                        : "N/A"
                    }}
                  </span>
                </div>
                <div class="date-label-col">
                  <span class="field-value">
                    {{
                      measure?.EndDate
                        ? (measure.EndDate | date: "shortDate" : "" : locale)
                        : "N/A"
                    }}
                  </span>
                </div>
                <div class="progress-label-col">
                  <span class="progress-top-value">
                    {{ measure?.ProgressPercentage ?? 0 }}%
                  </span>
                  <div class="progress-bar-track">
                    <div
                      class="progress-bar-fill"
                      [style.width.%]="measure.ProgressPercentage || 0"
                    ></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="chips-row">
              <div class="chips-left">
                <span class="chip chip-grade">{{ measure.CurrentGrade }}</span>
              </div>

              <div class="chips-right">
                @if (measure.TotalScore) {
                  <span
                    class="chip chip-score"
                    (mouseenter)="showScoreTooltip($event, measure)"
                    (mouseleave)="hideScoreTooltip()"
                  >
                    {{ measure.TotalScore }} / {{ maxScore }}
                  </span>
                }
                @if (
                  measure.ApprovalStatus &&
                    getApprovalConfig(measure.ApprovalStatus);
                  as config
                ) {
                  <span class="chip chip-approval" [ngClass]="config.class">
                    {{ config.text }}
                  </span>
                }
                <span
                  class="chip chip-status"
                  [ngClass]="'status-' + getStatusClass(measure.Status)"
                >
                  {{ dataService.res("Ubt-Measure-List-" + measure.Status) }}
                </span>
              </div>
            </div>

            <div class="collaborators-section">
              <span class="field-label">{{
                dataService.res("Ubt-CreateMeasureTask-Collaborators")
              }}</span>
              @if (measure.Person?.length > 0) {
                <div class="collaborators-list">
                  @for (
                    person of measure.showAllCollaborators
                      ? measure.Person
                      : measure.Person.slice(0, 2);
                    track person
                  ) {
                    <span class="collaborator-tag">{{ person }}</span>
                  }
                  @if (
                    !measure.showAllCollaborators && measure.Person.length > 2
                  ) {
                    <button
                      class="more-btn"
                      (click)="toggleCollaborators(measure, $event)"
                    >
                      +{{ measure.Person.length - 2 }}
                    </button>
                  }
                  @if (measure.showAllCollaborators) {
                    <button
                      class="more-btn"
                      (click)="toggleCollaborators(measure, $event)"
                    >
                      {{ dataService.res("Ubt-Measure-Detail-ShowMore") }}
                    </button>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </abc-card>
    }
  </div>

  @if (!measures || measures.length === 0) {
    <div class="empty-state">
      <div class="empty-icon">📋</div>
      <p>{{ noDataText }}</p>
    </div>
  }
</div>

<dx-tooltip
  [target]="cardScoreTooltipTarget"
  [visible]="isCardScoreTooltipVisible"
  position="top"
>
  <div *dxTemplate="let data of 'content'">
    @if (scoreTooltipData) {
      <div class="score-tooltip">
        <div class="tooltip-row">
          <span class="icon-small" [innerHTML]="iconSvg | safeHtml"></span>
          <span>{{ dataService.res("Ubt-Measure-List-Effort") }}:</span>
          <strong>{{ scoreTooltipData.Effort }}/{{ ratingCount }}</strong>
        </div>
        <div class="tooltip-row">
          <span class="curr-icon-small" [innerHTML]="euroSvg | safeHtml"></span>
          <span>{{ dataService.res("Ubt-Measure-List-Benefit") }}:</span>
          <strong>{{ scoreTooltipData.Benefit }}/{{ ratingCount }}</strong>
        </div>
        <div class="tooltip-row">
          <span class="curr-icon-small" [innerHTML]="euroSvg | safeHtml"></span>
          <span>P&amp;L:</span>
          <strong>{{
            scoreTooltipData.Impact | currency: "EUR" : "symbol" : "1.0-0"
          }}</strong>
        </div>
        <div class="tooltip-row">
          <span class="curr-icon-small" [innerHTML]="euroSvg | safeHtml"></span>
          <span>{{ dataService.res("Ubt-Measure-List-Cost") }}:</span>
          <strong>{{
            scoreTooltipData.Cost | currency: "EUR" : "symbol" : "1.0-0"
          }}</strong>
        </div>
      </div>
    }
  </div>
</dx-tooltip>
